// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + {"184":"misc1","325":"form","886":"commerce"}[chunkId] + "." + {"184":"ad39f0b9","325":"f76c09a9","886":"42e6c648"}[chunkId] + ".bundle.js";
};